import { NavLink } from "react-router-dom";
import { ShieldCheck, LayoutDashboard, Users } from "lucide-react";

const NAV_ITEMS = [
  { to: "/access", label: "Org Access", icon: ShieldCheck },
  { to: "/admin", label: "Super-Admin", icon: LayoutDashboard },
];

export function NavBar() {
  return (
    <nav className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="mx-auto flex max-w-5xl items-center gap-1 px-6 py-0">
        {/* Brand */}
        <div className="mr-4 flex items-center gap-2 py-3">
          <Users className="h-4 w-4 text-indigo-600" />
          <span className="text-sm font-semibold tracking-tight text-slate-800">
            SiGaN IAM
          </span>
        </div>

        {/* Nav links */}
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              [
                "flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-indigo-50 text-indigo-700"
                  : "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
              ].join(" ")
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
